import { useMemo } from "react";
import { Checkbox, Loader } from "semantic-ui-react";
import { useNotifySubscriberContactMethodsForLoggedInUser } from "../../../../../../../hooks/useNotifySubscriberContactMethodsForLoggedInUser";
import { useNotifySubscriptionPreferenceUpdate } from "../../../../../../../hooks/useNotifySubscriptionPreferenceUpdate";

export function PreferenceCheckbox({
  groupId,
  subscriberContactMethodId,
  label,
  type,
  disabled = false,
  forceOff = false,
  onOpenModal = () => {},
}: {
  groupId: number;
  subscriberContactMethodId?: number;
  label?: string;
  type: "Email" | "Phone";
  disabled?: boolean;
  forceOff?: boolean;
  onOpenModal?: () => void;
}) {
  const { subscriberContactMethods } = useNotifySubscriberContactMethodsForLoggedInUser();
  const firstMethod = subscriberContactMethods?.[0];
  const subscriberContactMethod = subscriberContactMethodId
    ? subscriberContactMethods?.find((method) => method.id === subscriberContactMethodId)
    : firstMethod;
  const { editSubscriptionPreference, isEditSubscriptionPreferenceLoading } = useNotifySubscriptionPreferenceUpdate();

  const toggleSubscriptionPreference = async () => {
    if (!subscriberContactMethod) return;

    if (subscriberContactMethod.type !== type) {
      onOpenModal();
      return;
    }

    const existingGroup = subscriberContactMethod.subscriptionGroups.find((group) => group.id === groupId);
    const toggledType = existingGroup ? "Unsubscribe" : "Subscribe";

    await editSubscriptionPreference({
      subscriptionGroupId: groupId,
      subscriberContactMethodId: subscriberContactMethod.id,
      type: toggledType,
    });
  };

  const groupIdSet = useMemo(
    () => new Set(subscriberContactMethod?.subscriptionGroups.map((group) => group.id)),
    [subscriberContactMethod],
  );

  const isCheckboxChecked = subscriberContactMethod?.type === type && groupIdSet.has(groupId);

  return (
    <div className='tw-flex tw-items-center tw-gap-3'>
      <Checkbox
        label={label}
        toggle
        checked={isCheckboxChecked && !forceOff}
        onChange={toggleSubscriptionPreference}
        disabled={isEditSubscriptionPreferenceLoading || disabled}
      />
      <Loader active={isEditSubscriptionPreferenceLoading} size='tiny' inline />
    </div>
  );
}
